import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2367acc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"main-grid headers\" data-v-2367acc2><div class=\"title\" data-v-2367acc2> </div><div class=\"title\" data-v-2367acc2>Date</div><div class=\"title\" data-v-2367acc2>Deduct Branch</div><div class=\"title\" data-v-2367acc2>Add Branch</div><div class=\"title\" data-v-2367acc2>Summary Orders</div><div class=\"title\" data-v-2367acc2>General<br data-v-2367acc2>Printing</div><div class=\"title\" data-v-2367acc2>General<br data-v-2367acc2>Disp. Asf Print Only</div><div class=\"title\" data-v-2367acc2>General<br data-v-2367acc2>Disp. Asf Framed</div><div class=\"title\" data-v-2367acc2>Magnum<br data-v-2367acc2>Printing</div><div class=\"title\" data-v-2367acc2>Magnum<br data-v-2367acc2>Disp. Asf Print Only</div><div class=\"title\" data-v-2367acc2>Magnum<br data-v-2367acc2>Disp. Asf Framed</div></div>", 1)
const _hoisted_3 = { class: "main-grid add-new-row" }
const _hoisted_4 = { class: "cell action-cell" }
const _hoisted_5 = { class: "cell" }
const _hoisted_6 = { class: "cell" }
const _hoisted_7 = { class: "cell" }
const _hoisted_8 = { class: "cell" }
const _hoisted_9 = { class: "cell" }
const _hoisted_10 = { class: "cell" }
const _hoisted_11 = { class: "cell" }
const _hoisted_12 = { class: "cell" }
const _hoisted_13 = { class: "cell" }
const _hoisted_14 = { class: "cell" }
const _hoisted_15 = { class: "note-row" }
const _hoisted_16 = {
  key: 0,
  class: "main-grid data-grid"
}
const _hoisted_17 = { class: "note-row" }
const _hoisted_18 = {
  key: 1,
  class: "empty-data-grid"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "k-icon k-font-icon k-i-loading",
  style: {"font-size":"64px"}
}, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: { margin: '25px', textAlign: 'center' } }, " This action cannot be undone. ", -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Delete")

import { ref, Ref, computed, onMounted } from "vue";
import {
  branches,
  emptyPostCalculationAdjustment,
  PostCalculationAdjustment,
} from "@/core/types/post-calculation-adjustments/postCalculationAdjustment";
import { DropDownList as KDropDownList } from "@progress/kendo-vue-dropdowns";
import { NumericTextBox as KNumericTextBox } from "@progress/kendo-vue-inputs";
import { DatePicker as KDatePicker } from "@progress/kendo-vue-dateinputs";
import { Button as KButton } from "@progress/kendo-vue-buttons";
import { Input as KInput } from "@progress/kendo-vue-inputs";
import {
  Dialog as KDialog,
  DialogActionsBar as KDialogActionsBar,
} from "@progress/kendo-vue-dialogs";
import {
  deleteAdjustment,
  loadAdjustments,
  saveAdjustment,
} from "@/core/services/productivityDashboard";
import { Notification as KNotification } from "@progress/kendo-popups-vue-wrapper";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const newAdjustment = ref(emptyPostCalculationAdjustment());
const isDataLoading = ref(false);
const isLoading = ref(false);
const emptyStateMessage = ref("No data found");

const adjustments: Ref<PostCalculationAdjustment[]> = ref([]);
const hasDataItems = computed(() => adjustments.value.length > 0);
const showDeleteConfirmationDlg = ref(false);
const selectedAdjustment: Ref<PostCalculationAdjustment | null> = ref(null);
const popupNotification: any = ref(null);
let popupNotificationWidget: any = null;

onMounted(async () => {
  await loadData();
  popupNotificationWidget = popupNotification.value?.kendoWidget();
});

const isFirstRow = (rindex: number) => rindex == 0;

const loadData = async () => {
  try {
    isDataLoading.value = true;
    adjustments.value = await loadAdjustments();
  } catch (e: any) {
    if (e.message) {
      emptyStateMessage.value = `[ERROR]: ${e.message}`;
      popupNotificationWidget.show("Adjustment failed to be added", "error");
      console.error(e);
    }
  } finally {
    isDataLoading.value = false;
  }
};

const onAddNewRow = async (event: any): Promise<void> => {
  try {
    isLoading.value = true;
    await saveAdjustment(newAdjustment.value);
    await loadData();
    popupNotificationWidget.show(
      "New adjustment successfully added",
      "success",
    );
  } catch (e: unknown) {
    popupNotificationWidget.show("Adjustment failed to be added", "error");
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

const onSave = async (item: PostCalculationAdjustment): Promise<void> => {
  try {
    item.IsLoading = true;
    item.ActionTriggered = "save";
    await saveAdjustment(item);
    await loadData();
    popupNotificationWidget.show("Adjustment successfully saved", "success");
  } catch (e: unknown) {
    popupNotificationWidget.show("Adjustment failed to be saved", "error");
    console.error(e);
  } finally {
    item.IsLoading = false;
    item.ActionTriggered = null;
  }
};

const onDelete = async (): Promise<void> => {
  try {
    if (!selectedAdjustment.value) return;

    showDeleteConfirmationDlg.value = !showDeleteConfirmationDlg.value;
    selectedAdjustment.value.IsLoading = true;
    selectedAdjustment.value.ActionTriggered = "delete";
    await deleteAdjustment(selectedAdjustment.value);
    await loadData();
    popupNotificationWidget.show("Adjustment successfully deleted", "success");
    selectedAdjustment.value = null;
  } catch (e: unknown) {
    popupNotificationWidget.show("Adjustment failed to be deleted", "error");
    console.error(e);
  } finally {
    if (selectedAdjustment.value) {
      selectedAdjustment.value.IsLoading = false;
      selectedAdjustment.value.ActionTriggered = null;
    }
  }
};

const onToggleDialog = (adjustment?: PostCalculationAdjustment) => {
  if (adjustment) {
    selectedAdjustment.value = adjustment;
  }
  showDeleteConfirmationDlg.value = !showDeleteConfirmationDlg.value;
};

const onBranchChange = (
  event: any,
  adjustment: PostCalculationAdjustment,
  branchType: "A" | "D",
) => {
  switch (branchType) {
    case "A":
      adjustment.AddBranch = event.value;
      break;
    case "D":
      adjustment.DeductBranch = event.value;
      break;
    default:
      break;
  }
};
const onDateChange = (event: any, adjustment: PostCalculationAdjustment) => {
  adjustment.Date = event.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(KButton), { disabled: isLoading.value }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass(["k-icon k-font-icon", [isLoading.value ? 'k-i-loading' : 'k-i-plus-circle']]),
                onClick: onAddNewRow
              }, null, 2)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(KDatePicker), {
            value: newAdjustment.value.Date,
            format: 'd MMM yy',
            onChange: _cache[0] || (_cache[0] = ($event: any) => (onDateChange($event, newAdjustment.value)))
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(KDropDownList), {
            "data-items": _unref(branches),
            "text-field": 'Name',
            "data-item-key": 'Id',
            value: newAdjustment.value.DeductBranch,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (onBranchChange($event, newAdjustment.value, 'D')))
          }, null, 8, ["data-items", "value"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_unref(KDropDownList), {
            "data-items": _unref(branches),
            "text-field": 'Name',
            "data-item-key": 'Id',
            value: newAdjustment.value.AddBranch,
            onChange: _cache[2] || (_cache[2] = ($event: any) => (onBranchChange($event, newAdjustment.value, 'A')))
          }, null, 8, ["data-items", "value"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_unref(KNumericTextBox), {
            modelValue: newAdjustment.value.SummaryOrders,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newAdjustment.value.SummaryOrders) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(KNumericTextBox), {
            modelValue: newAdjustment.value.GeneralPrintingPrints,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newAdjustment.value.GeneralPrintingPrints) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_unref(KNumericTextBox), {
            modelValue: newAdjustment.value.GeneralDispatchAsfPrintOnlyOrders,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newAdjustment.value.GeneralDispatchAsfPrintOnlyOrders) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(KNumericTextBox), {
            modelValue: newAdjustment.value.GeneralDispatchAsfFramedOrders,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newAdjustment.value.GeneralDispatchAsfFramedOrders) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_unref(KNumericTextBox), {
            modelValue: newAdjustment.value.MagnumPrintingPrints,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((newAdjustment.value.MagnumPrintingPrints) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_unref(KNumericTextBox), {
            modelValue: newAdjustment.value.MagnumDispatchAsfPrintOnlyOrders,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((newAdjustment.value.MagnumDispatchAsfPrintOnlyOrders) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_unref(KNumericTextBox), {
            modelValue: newAdjustment.value.MagnumDispatchAsfFramedOrders,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newAdjustment.value.MagnumDispatchAsfFramedOrders) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_unref(KInput), {
            modelValue: newAdjustment.value.Note,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((newAdjustment.value.Note) = $event)),
            placeholder: 'Write your notes here and click on the plus button to add the new manual adjustment'
          }, null, 8, ["modelValue"])
        ])
      ]),
      (_unref(hasDataItems))
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(adjustments.value, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["cell action-cell", { 'with-top-border': !isFirstRow(index) }])
                }, [
                  _createVNode(_unref(KButton), {
                    disabled: item.IsLoading,
                    onClick: ($event: any) => (onSave(item))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass(["k-icon k-font-icon", [
                  item.IsLoading && item?.ActionTriggered == 'save'
                    ? 'k-i-loading'
                    : 'k-i-save',
                ]])
                      }, null, 2)
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"]),
                  _createVNode(_unref(KButton), {
                    disabled: item.IsLoading,
                    onClick: ($event: any) => (onToggleDialog(item))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass(["k-icon k-font-icon", [
                  item.IsLoading && item?.ActionTriggered == 'delete'
                    ? 'k-i-loading'
                    : 'k-i-delete',
                ]])
                      }, null, 2)
                    ]),
                    _: 2
                  }, 1032, ["disabled", "onClick"])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["cell", { 'with-top-border': !isFirstRow(index) }])
                }, [
                  _createVNode(_unref(KDatePicker), {
                    value: item.Date,
                    format: 'd MMM yy',
                    onChange: ($event: any) => (onDateChange($event, item))
                  }, null, 8, ["value", "onChange"])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["cell", { 'with-top-border': !isFirstRow(index) }])
                }, [
                  _createVNode(_unref(KDropDownList), {
                    "data-items": _unref(branches),
                    "text-field": 'Name',
                    "data-item-key": 'Id',
                    value: item.DeductBranch,
                    onChange: ($event: any) => (onBranchChange($event, item, 'D'))
                  }, null, 8, ["data-items", "value", "onChange"])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["cell", { 'with-top-border': !isFirstRow(index) }])
                }, [
                  _createVNode(_unref(KDropDownList), {
                    "data-items": _unref(branches),
                    "text-field": 'Name',
                    "data-item-key": 'Id',
                    value: item.AddBranch,
                    onChange: ($event: any) => (onBranchChange($event, item, 'A'))
                  }, null, 8, ["data-items", "value", "onChange"])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["cell", { 'with-top-border': !isFirstRow(index) }])
                }, [
                  _createVNode(_unref(KNumericTextBox), {
                    modelValue: item.SummaryOrders,
                    "onUpdate:modelValue": ($event: any) => ((item.SummaryOrders) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["cell", { 'with-top-border': !isFirstRow(index) }])
                }, [
                  _createVNode(_unref(KNumericTextBox), {
                    modelValue: item.GeneralPrintingPrints,
                    "onUpdate:modelValue": ($event: any) => ((item.GeneralPrintingPrints) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["cell", { 'with-top-border': !isFirstRow(index) }])
                }, [
                  _createVNode(_unref(KNumericTextBox), {
                    modelValue: item.GeneralDispatchAsfPrintOnlyOrders,
                    "onUpdate:modelValue": ($event: any) => ((item.GeneralDispatchAsfPrintOnlyOrders) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["cell", { 'with-top-border': !isFirstRow(index) }])
                }, [
                  _createVNode(_unref(KNumericTextBox), {
                    modelValue: item.GeneralDispatchAsfFramedOrders,
                    "onUpdate:modelValue": ($event: any) => ((item.GeneralDispatchAsfFramedOrders) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["cell", { 'with-top-border': !isFirstRow(index) }])
                }, [
                  _createVNode(_unref(KNumericTextBox), {
                    modelValue: item.MagnumPrintingPrints,
                    "onUpdate:modelValue": ($event: any) => ((item.MagnumPrintingPrints) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["cell", { 'with-top-border': !isFirstRow(index) }])
                }, [
                  _createVNode(_unref(KNumericTextBox), {
                    modelValue: item.MagnumDispatchAsfPrintOnlyOrders,
                    "onUpdate:modelValue": ($event: any) => ((item.MagnumDispatchAsfPrintOnlyOrders) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["cell", { 'with-top-border': !isFirstRow(index) }])
                }, [
                  _createVNode(_unref(KNumericTextBox), {
                    modelValue: item.MagnumDispatchAsfFramedOrders,
                    "onUpdate:modelValue": ($event: any) => ((item.MagnumDispatchAsfFramedOrders) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ], 2),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_unref(KInput), {
                    modelValue: item.Note,
                    "onUpdate:modelValue": ($event: any) => ((item.Note) = $event),
                    placeholder: 'Write your notes here'
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ])
              ], 64))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("h3", null, [
              (isDataLoading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _hoisted_21))
                : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(emptyStateMessage.value), 1))
            ])
          ]))
    ]),
    (showDeleteConfirmationDlg.value)
      ? (_openBlock(), _createBlock(_unref(KDialog), {
          key: 0,
          title: 'Delete Data',
          onClose: _cache[12] || (_cache[12] = ($event: any) => (onToggleDialog()))
        }, {
          default: _withCtx(() => [
            _hoisted_23,
            _createVNode(_unref(KDialogActionsBar), null, {
              default: _withCtx(() => [
                _createVNode(_unref(KButton), {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (onToggleDialog()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 1
                }),
                _createVNode(_unref(KButton), {
                  "theme-color": 'primary',
                  onClick: onDelete
                }, {
                  default: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(KNotification), {
      ref_key: "popupNotification",
      ref: popupNotification
    }, null, 512)
  ]))
}
}

})